import React, { forwardRef } from 'react';

export const NavbarItem = forwardRef(
    ({ icon, info, onClick, showInfo = false }, ref) => {
        return (
            <div ref={ref} className={'searchbar-item'} onClick={onClick}>
                <span className={'searchbar-item__icon'}>{icon}</span>
                {showInfo && (
                    <div className={'searchbar-item__info'}>{info}</div>
                )}
            </div>
        );
    }
);
